import { BUTTON_ICONS } from './button-icons';
import { CORPORATE_ICONS } from './corporate-icons';
import { DETAIL_ICONS } from './detail-icons';
import { ENTITY_ICONS } from './entity-icons';
import { APPLICATION } from './license-icons';
import { NAVIGATION_ICONS } from './navigation-icons';
import { PUDO_ICONS } from './pudo-icons';

export const ICONS = {
    ORGANIZATION: ENTITY_ICONS,
    ENTITY: ENTITY_ICONS,
    BUTTON: BUTTON_ICONS,
    NAVIGATION: NAVIGATION_ICONS,
    APPLICATION: APPLICATION,
    PUDO: PUDO_ICONS,
    DETAIL: DETAIL_ICONS,
    CORPORATE: CORPORATE_ICONS
};
